import fixture from './PublicCases.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, IPublicCasesClient } from 'interfaceAdapter/gatewaySchemas/IPublicCasesClient';
import { getCookie } from 'utils/cookie';
const csrfToken = getCookie('csrftoken');

export class PublicCasesClient implements IPublicCasesClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { mock = false } = input;

        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };
        const PATH = `${API_LOCATION_URL}/public/cases`;
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
